module.exports = __webpack_public_path__ + "static/media/belt-replacement.2d639621.svg";